export enum ConsumerRouteSearchParam {
  Reset = 'reset',
  Email = 'email',
}
